import { API_URL } from "config";
import Http from "util/https";
import { SaveProductSettingParams } from "../types";

/**
 * ジョイフル用取扱商品登録、更新、削除APIを呼び出します
 * @param params 商品操作リクエストパラメータ
 * @returns {Promise<number>} レスポンスステータスコード
 */
const productEditDataApi = async (params: SaveProductSettingParams): Promise<number> => {
  console.log('productEditDataApi params:', params);
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/joyful/item/edit`;
  const res = await http.post<void>(url, params);
  console.log(res);

  return res.status;
};

export default productEditDataApi;
